<template>
  <div class="survey-form-page">
    <!-- <header class="page-header">
      <button class="back-button" type="button" aria-label="返回" @click="$router.back()">‹</button>
      <span>物流服务满意度调查</span>
    </header> -->
    <main class="content">
      <div class="page-top">
        <img src="@/assets/image/share/page-top.png" alt="">
      </div>
      <!-- <section class="hero"><strong>物流服务满意度调查</strong><span>您的反馈是我们前进的动力</span></section> -->
      <div class="form-content">
        <section class="question-card">
          <div class="notice-bg">
              <img src="@/assets/image/share/center-logo.png" alt="">
          </div>
          <div class="notice-title"><div class="notice-title-text">调查服务时间范围：{{ serviceDateRange }}</div></div>
          <div class="notice-bottom"></div>
          <div class="notice-body">
              <p>尊敬的客户您好：</p>
              <p>为持续优化我司物流服务品质，完善服务质量管理体系，进一步提升运输、对接及售后综合服务能力，更好地匹配贵司业务需求，现诚挚邀请您对我司近期的物流产品与服务开展评价。烦请您结合实际合作体验完成本次满意度调查，并对我们服务中存在的不足提出宝贵改进意见，助力我们持续改进提升。感谢贵司一直以来的信任与支持！</p>
          </div>
        </section>
        <section class="basic-form">
          <div class="center-line">
              <svg xmlns="http://www.w3.org/2000/svg" width="344" height="1" viewBox="0 0 344 1" fill="none">
                  <path d="M0.5 0.5H343.5" stroke="black" stroke-linecap="round" stroke-dasharray="5 8"/>
              </svg>
          </div>
          <article v-for="(question, index) in questions" :key="question.key" class="question-item">
            <div class="question-title"><i v-if="question.required">*</i>{{ index + 1 }}.{{ question.title }}<span v-if="question.type === 'radio'">（单选）</span><span v-else-if="question.type === 'checkbox'">（多选）</span></div>
            <p v-if="question.description" class="question-description">{{ question.description }}</p>
            <template v-if="question.type === 'radio'">
              <label v-for="option in question.options" :key="option.value || option" class="option">
                <input v-model="answers[question.key]" type="radio" :name="question.key" :value="option.value || option">
                <span>{{ option.label || option }}</span>
              </label>
            </template>
            <template v-else-if="question.type === 'checkbox'">
              <label v-for="option in question.options" :key="option.value || option" class="option">
                <input v-model="answers[question.key]" type="checkbox" :value="option.value || option">
                <span>{{ option.label || option }}</span>
              </label>
              <input
                v-if="answers[question.key].includes(1)"
                v-model.trim="cooperationProjectOther"
                class="other-input"
                type="text"
                max-length="40"
                placeholder="请输入其他类型"
              >
            </template>
            <textarea v-else-if="question.type === 'textarea'" v-model.trim="answers[question.key]" :placeholder="question.placeholder" maxlength="500" />
            <button v-else class="signature-box" type="button" @click="goSignature">
              <img v-if="answers.signatureUrl" :src="answers.signatureUrl" alt="客户签名">
              <span v-else>请点击此处手写签名</span>
            </button>
          </article>
        </section>
      </div>
    </main>
    <footer class="page-footer">
      <button type="button" class="previous-button" @click="$router.back()">上一页</button>
      <button type="button" class="submit-button" @click="submitSurvey">提交</button>
    </footer>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { submitSatisfactionSurvey } from '@/api/beecargo/satisfactionSurvey';

const STORAGE_KEY = 'beecargo-satisfaction-survey';
const SATISFACTION_OPTIONS = [
  { label: '非常满意', value: 10 },
  { label: '基本满意', value: 8 },
  { label: '一般', value: 7 },
  { label: '不太满意', value: 5 },
  { label: '非常差', value: 1 }
];

export default {
  name: 'SatisfactionSurveyForm',
  data() {
    return {
      questions: [
        { key: 'cooperationProject', title: '合作项目名称', type: 'checkbox', required: true, options: [
          { label: '零担', value: 5 },
          { label: '整车', value: 4 },
          { label: '同城配送', value: 3 },
          { label: '国际货运代理', value: 2 },
          { label: '其它', value: 1 }
        ] },
        { key: 'scoreTimeliness', title: '运输时效', type: 'radio', required: true, options: SATISFACTION_OPTIONS, description: '整体时效稳定，无无故延误，超时情况少，异常情况有主动提前告知客户。' },
        { key: 'scoreCargoSafety', title: '货物安全', type: 'radio', required: true, options: SATISFACTION_OPTIONS, description: '货物无丢失、破损、受潮、污染。货物装卸规范、防护到位。' },
        { key: 'scoreDispatch', title: '调度配合度', type: 'radio', required: true, options: SATISFACTION_OPTIONS, description: '及时安排车辆，提供车辆信息，安排车辆符合要求。' },
        { key: 'scoreDriverVehicle', title: '司机/车辆质量', type: 'radio', required: true, options: SATISFACTION_OPTIONS, description: '提/送货准时、司机配合度高，态度良好;车辆整洁，密封性高、签收规范，卸货整洁有序。' },
        { key: 'scoreServiceResponse', title: '客服响应效率', type: 'radio', required: true, options: SATISFACTION_OPTIONS, description: '咨询回复及时、沟通专业，可实时跟进货物轨迹、对接顺畅。' },
        { key: 'scoreExceptionHandle', title: '异常处理能力', type: 'radio', required: true, options: SATISFACTION_OPTIONS, description: '延误、破损、丢件等异常问题处理及时，提供解决方案合理。' },
        { key: 'scorePrice', title: '价格性价比', type: 'radio', required: true, options: SATISFACTION_OPTIONS, description: '收费透明、报价合理，无隐形收费，价格与服务匹配。' },
        { key: 'scoreBill', title: '单据与对账服务', type: 'radio', required: true, options: SATISFACTION_OPTIONS, description: '运单信息准确，对账清晰、开票及时，资料规范。' },
        { key: 'scoreCompare', title: '与其他物流供应商对比', type: 'radio', required: true, options: SATISFACTION_OPTIONS, description: '我司提供的服务与其他供应商对比是否更安全、更优惠、服务更好、配合度更高。' },
        { key: 'scoreOverall', title: '整体服务体验', type: 'radio', required: true, options: SATISFACTION_OPTIONS, description: '综合整体物流服务感受。' },
        { key: 'improveSuggestion', title: '您对我们服务最满意的地方是什么?', type: 'textarea', required: false, placeholder: '请输入内容' },
        { key: 'improveSuggestionTwo', title: '您认为我们最需要改进的地方是什么?', type: 'textarea', required: false, placeholder: '请输入内容' },
        { key: 'improveSuggestionThree', title: '您希望我们增加或优化哪些服务? (如增值服务、系统功能、覆盖范围等)', type: 'textarea', required: false, placeholder: '请输入内容' },
        { key: 'signatureUrl', title: '客户代表签字', type: 'signature', required: true, description: '感谢您的评价与反馈，您的意见将作为我司持续改善服务质量的重要依据。' }
      ],
      answers: {
        cooperationProject: []
      },
      cooperationProjectOther: '',
      surveyInfo: {
        serviceStartMonth: '',
        serviceEndMonth: ''
      }
    };
  },
  computed: {
    serviceDateRange() {
      const { serviceStartMonth, serviceEndMonth } = this.surveyInfo;
      if (!serviceStartMonth || !serviceEndMonth) return '--';
      return `${this.formatMonth(serviceStartMonth)}~${this.formatMonth(serviceEndMonth)}`;
    }
  },
  created() {
    const saved = this.getSavedSurvey();
    this.answers = Object.assign({
      cooperationProject: []
    }, saved.answers);
    if (!Array.isArray(this.answers.cooperationProject)) {
      this.answers.cooperationProject = this.answers.cooperationProject
        ? this.answers.cooperationProject.split(',')
        : [];
    }
    this.cooperationProjectOther = saved.cooperationProjectOther || '';
    if (saved.surveyInfo) {
      this.surveyInfo = saved.surveyInfo;
    }
  },
  mounted() {
    this.restoreSignatureScrollPosition();
  },
  methods: {
    getSavedSurvey() {
      try {
        return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
      } catch (error) {
        return {};
      }
    },
    formatMonth(value) {
      return value ? value.slice(0, 7) : '';
    },
    saveDraft() {
      const saved = this.getSavedSurvey();
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Object.assign({}, saved, {
        answers: this.answers,
        cooperationProjectOther: this.cooperationProjectOther
      })));
    },
    restoreSignatureScrollPosition() {
      const saved = this.getSavedSurvey();
      const scrollTop = Number(saved.signatureScrollTop);
      if (!Number.isFinite(scrollTop)) return;
      delete saved.signatureScrollTop;
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
      this.$nextTick(() => {
        window.requestAnimationFrame(() => window.scrollTo(0, scrollTop));
      });
    },
    async goSignature() {
      this.saveDraft();
      const saved = this.getSavedSurvey();
      const signatureScrollTop = window.pageYOffset
        || document.documentElement.scrollTop
        || document.body.scrollTop
        || 0;
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Object.assign({}, saved, {
        signatureScrollTop
      })));
      try {
        const isMobile = window.innerWidth < 768;
        if (isMobile && document.documentElement.requestFullscreen && !document.fullscreenElement) {
          await document.documentElement.requestFullscreen();
        }
        if (isMobile && screen.orientation && screen.orientation.lock) {
          await screen.orientation.lock('landscape');
        }
      } catch (error) {
        // 全屏和方向锁定必须由用户手势触发；不支持时仍可进入签名页。
      }
      this.$router.push('/beecargo/satisfactionSurvey/signature');
    },
    async submitSurvey() {
      const emptyQuestion = this.questions.find(question => {
        const answer = this.answers[question.key];
        return question.required && (!answer || (Array.isArray(answer) && !answer.length));
      });
      if (emptyQuestion) {
        Toast(`请填写第${this.questions.indexOf(emptyQuestion) + 1}题：${emptyQuestion.title}`);
        return;
      }
      if (this.answers.cooperationProject.includes(1) && !this.cooperationProjectOther) {
        Toast('请输入其他合作项目类型');
        return;
      }
      this.saveDraft();
      const { basic = {} } = this.getSavedSurvey();
      const payload = Object.assign({
        surveyCode: basic.surveyCode,
        companyName: basic.companyName,
        contactName: basic.customerName,
        contactPhone: basic.phone
      }, this.answers);
      const cooperationProjectQuestion = this.questions.find(question => question.key === 'cooperationProject');
      payload.cooperationProject = this.answers.cooperationProject.join(',');
      payload.cooperationProjectName = this.answers.cooperationProject
        .map(value => {
          if (value === 1) return this.cooperationProjectOther;
          const option = cooperationProjectQuestion.options.find(item => item.value === value);
          return option ? option.label : '';
        })
        .filter(Boolean)
        .join(',');
      try {
        await submitSatisfactionSurvey(payload);
        this.$router.replace('/beecargo/satisfactionSurvey/success');
      } catch (error) {
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.survey-form-page { 
  min-height: 100vh; 
  padding-bottom: 76px; 
  background: linear-gradient(180deg, #ff733c, #ffb246);
  color: #3d3833;
  img {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
.page-header { height: 44px; position: relative; display: flex; align-items: center; justify-content: center; background: #fff; font-size: 17px; }
.back-button { position: absolute; left: 12px; border: 0; padding: 0 6px 4px; background: transparent; color: #3d3833; font-size: 32px; }
.content { padding: 0 0 12px;background: linear-gradient(180deg, #FF733C 0%, #FFB246 100%); }
.hero { display: flex; height: 124px; margin: 0 -12px 16px; padding: 28px; flex-direction: column; justify-content: center; color: #f26d22; background: linear-gradient(145deg, #fffdf8, #ffe5c2 55%, #ff8b39); }
.hero strong { font-size: 24px; font-style: italic; }
.hero span { margin-top: 8px; color: #716356; font-size: 12px; }
.question-card,.basic-form { border-radius: 4px; background: #fff;position: relative; }
.page-top {
  width: 100%;
  height: 188px;
  margin-bottom: 16px;
}
.form-content {padding: 0 12px;}
.notice-bg {
    width: 200px;
    height: 200px;
    position: absolute;
    top: 51px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    opacity: .4;
    img {
        width: 100%;
        height: 100%;
    }
}
.notice-title { padding: 4px 0 8px; background: #ffffff;border-radius: 4px 4px 0 0; }
.notice-bottom { width: 100%; height: 8px; background: #ff733c; }
.notice-body { padding: 8px 16px; font-size: 16px; line-height: 24px;z-index: 2; }
.notice-body p { margin: 0; }
.notice-body p + p { text-indent: 2em;position: relative;z-index: 2; }
.basic-form { 
    padding: 4px 16px;
    position: relative;
    .center-line {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        font-size: 0;
        display: flex;
        justify-content: center;
    }
}
.notice-title-text { padding: 10px 16px; background: #ff733c; color: #fff; font-size: 16px;border-radius: 4px 4px 0 0; }
.question-item { padding: 16px; border-bottom: 1px solid #eee5dc; }
.question-item:last-child { border-bottom: 0; }
.question-title { font-size: 16px; line-height: 24px;color:#241F1B; }
.question-title i { color: #ff484a; font-style: normal; }
.question-description { margin: 8px 0; color: #716356; font-size: 14px; line-height: 22px; }
.option { display: flex; align-items: center; min-height: 32px; margin-left: 8px; color: #716356; font-size: 16px; }
.option input[type='radio'] {
  appearance: none;
  -webkit-appearance: none;
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  margin: 0 12px 0 0;
  border: 1px solid #d9cbbe;
  border-radius: 50%;
  background: #fff;
  flex-shrink: 0;
}
.option input[type='radio']:checked {
  border-color: #f1892e;
  background-color: #f1892e;
  box-shadow: inset 0 0 0 3px #fff;
}
.option input[type='checkbox'] {
  appearance: none;
  -webkit-appearance: none;
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  margin: 0 12px 0 0;
  border: 1px solid #d9cbbe;
  border-radius: 2px;
  background-color: #fff;
  flex-shrink: 0;
}
.option input[type='checkbox']:checked {
  border-color: #F1892E;
  background: #F1892E url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='white' stroke-width='2' d='M3 8l3 3 7-7'/%3E%3C/svg%3E") center/14px 14px no-repeat;
}
.option input:checked + span { color: #f1892e; }
.other-input { box-sizing: border-box; width: 100%; height: 40px; margin-top: 8px; padding: 0 8px; border: 1px solid #d9cbbe; border-radius: 4px; font: inherit; outline: none; }
.other-input:focus { border-color: #f1892e; }
textarea { box-sizing: border-box; width: 100%; height: 120px; margin: 12px 0 0; padding: 8px; border: 1px solid #d9cbbe; border-radius: 4px; resize: vertical; font: inherit; line-height: 22px; outline: none; }
textarea:focus { border-color: #f1892e; }
.signature-box { display: flex; width: 100%; height: 160px; margin-top: 12px; align-items: center; justify-content: center; overflow: hidden; border: 1px solid #d9cbbe; border-radius: 4px; background: #fff; color: #716356; font-size: 14px; }
.signature-box img { max-width: 100%; max-height: 100%; object-fit: contain; }
.page-footer { position: fixed; z-index: 2; right: 0; bottom: 0; left: 0; display: flex; gap: 16px; padding: 6px 12px 10px; background: #fff; }
.page-footer button { height: 46px; border-radius: 4px; font-size: 14px; }
.previous-button { width: 30%; border: 1px solid #f1892e; background: #fff; color: #f1892e; }
.submit-button { flex: 1; border: 0; background: #f1892e; color: #fff; }

@media (min-width: 768px) {
  .content {
    box-sizing: border-box;
    width: 720px;
    margin: 0 auto;
    padding-bottom: 28px;
  }
  .page-top {
    height: 361px;
  }
  .form-content {
    padding: 0;
  }
  .question-card,
  .basic-form {
    border-radius: 8px;
  }
  .basic-form {
    margin-top: 16px;
    padding: 12px 32px;
  }
  .question-item {
    padding: 22px 16px;
  }
  .option {
    cursor: pointer;
  }
  .signature-box {
    height: 220px;
    cursor: pointer;
  }
  .page-footer {
    box-sizing: border-box;
    right: auto;
    left: 50%;
    width: 720px;
    padding: 10px 0 14px;
    transform: translateX(-50%);
  }
  .page-footer button {
    cursor: pointer;
  }
}
</style>
